/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ListItemTypeEnum = "containers" | "external_contacts" | "internal_contacts" | "item" | "messages" | "shipments" | "tickets" | "vessels" | "voyages" | "%future added value";
export type FilterInput = {
    key: string;
    values: Array<string>;
};
export type ItemListPaginationQueryVariables = {
    count?: number | null;
    cursor?: string | null;
    dischargeDateEnd?: string | null;
    dischargeDateStart?: string | null;
    filters?: Array<FilterInput> | null;
    handoverDateEnd?: string | null;
    handoverDateStart?: string | null;
    includeArchived?: boolean | null;
    page?: number | null;
    perPage?: number | null;
    searchQuery?: string | null;
    showFilters?: boolean | null;
    sortKey?: string | null;
    type?: ListItemTypeEnum | null;
    voyageEtaEnd?: string | null;
    voyageEtaStart?: string | null;
    voyageEtdEnd?: string | null;
    voyageEtdStart?: string | null;
};
export type ItemListPaginationQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"ItemList_data">;
};
export type ItemListPaginationQuery = {
    readonly response: ItemListPaginationQueryResponse;
    readonly variables: ItemListPaginationQueryVariables;
};



/*
query ItemListPaginationQuery(
  $count: Int
  $cursor: String
  $dischargeDateEnd: Date
  $dischargeDateStart: Date
  $filters: [FilterInput!]
  $handoverDateEnd: Date
  $handoverDateStart: Date
  $includeArchived: Boolean
  $page: Int
  $perPage: Int
  $searchQuery: String
  $showFilters: Boolean
  $sortKey: String
  $type: ListItemTypeEnum
  $voyageEtaEnd: Date
  $voyageEtaStart: Date
  $voyageEtdEnd: Date
  $voyageEtdStart: Date
) {
  ...ItemList_data
}

fragment Action_data on Action {
  type
  role
  cta
}

fragment Badge_data on Badge {
  type
}

fragment ContactLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  imageUrl
}

fragment ContainerLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
  badge {
    ...Badge_data
  }
}

fragment ItemImage_data on Image {
  url
  alt
  highlight
  shape
  overlay
  overlayIcon
}

fragment ItemList_data on ApplicationQuery {
  itemList(searchQuery: $searchQuery, type: $type, filters: $filters, includeArchived: $includeArchived, sortKey: $sortKey, page: $page, perPage: $perPage, handoverDateStart: $handoverDateStart, handoverDateEnd: $handoverDateEnd, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, showFilters: $showFilters) {
    items(first: $count, after: $cursor) {
      edges {
        node {
          slug
          ...ListPageItem_listItem
          id
          __typename
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}

fragment KeyField_data on KeyField {
  label
  value {
    key
    ...SemanticString_data
  }
}

fragment LinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
  entitySlug
  ...VoyageLinkCard_data
  ...VesselLinkCard_data
  ...ShipmentLinkCard_data
  ...ContainerLinkCard_data
  ...ContactLinkCard_data
}

fragment LinkSet_data on LinkSet {
  title
  inline
  links {
    key
    type
    ...LinkCard_data
  }
}

fragment ListPageItem_listItem on ListItem {
  slug
  title
  isArchived
  image {
    ...ItemImage_data
  }
  path
  statuses {
    key
    customsAgent
    value {
      ...SemanticString_data
    }
  }
  stages {
    key
    status
    label
    value
  }
  badges {
    key
    ...Badge_data
  }
  actions {
    key
    ...Action_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  keyFields {
    key
    ...KeyField_data
  }
  linkSets {
    key
    ...LinkSet_data
  }
  stickyNoteContent
}

fragment SemanticLine_data on SemanticLine {
  parts {
    key
    ...SemanticString_data
  }
}

fragment SemanticString_data on SemanticString {
  text
}

fragment ShipmentLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  badge {
    ...Badge_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
}

fragment VesselLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
}

fragment VoyageLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  voyageEta {
    ...SemanticString_data
  }
  voyageEtd {
    ...SemanticString_data
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dischargeDateEnd"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dischargeDateStart"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "handoverDateEnd"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "handoverDateStart"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeArchived"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "page"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "perPage"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchQuery"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "showFilters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "voyageEtaEnd"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "voyageEtaStart"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "voyageEtdEnd"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "voyageEtdStart"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "SemanticLine",
  "kind": "LinkedField",
  "name": "lines",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SemanticString",
      "kind": "LinkedField",
      "name": "parts",
      "plural": true,
      "selections": (v8/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemListPaginationQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ItemList_data"
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ItemListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "dischargeDateEnd",
            "variableName": "dischargeDateEnd"
          },
          {
            "kind": "Variable",
            "name": "dischargeDateStart",
            "variableName": "dischargeDateStart"
          },
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
          },
          {
            "kind": "Variable",
            "name": "handoverDateEnd",
            "variableName": "handoverDateEnd"
          },
          {
            "kind": "Variable",
            "name": "handoverDateStart",
            "variableName": "handoverDateStart"
          },
          {
            "kind": "Variable",
            "name": "includeArchived",
            "variableName": "includeArchived"
          },
          {
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
          },
          {
            "kind": "Variable",
            "name": "perPage",
            "variableName": "perPage"
          },
          {
            "kind": "Variable",
            "name": "searchQuery",
            "variableName": "searchQuery"
          },
          {
            "kind": "Variable",
            "name": "showFilters",
            "variableName": "showFilters"
          },
          {
            "kind": "Variable",
            "name": "sortKey",
            "variableName": "sortKey"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          },
          {
            "kind": "Variable",
            "name": "voyageEtaEnd",
            "variableName": "voyageEtaEnd"
          },
          {
            "kind": "Variable",
            "name": "voyageEtaStart",
            "variableName": "voyageEtaStart"
          },
          {
            "kind": "Variable",
            "name": "voyageEtdEnd",
            "variableName": "voyageEtdEnd"
          },
          {
            "kind": "Variable",
            "name": "voyageEtdStart",
            "variableName": "voyageEtdStart"
          }
        ],
        "concreteType": "ItemList",
        "kind": "LinkedField",
        "name": "itemList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ListItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ListItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ListItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isArchived",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "alt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "highlight",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shape",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "overlay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "overlayIcon",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "path",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Status",
                        "kind": "LinkedField",
                        "name": "statuses",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customsAgent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SemanticString",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stage",
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Badge",
                        "kind": "LinkedField",
                        "name": "badges",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Action",
                        "kind": "LinkedField",
                        "name": "actions",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cta",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "KeyField",
                        "kind": "LinkedField",
                        "name": "keyFields",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SemanticString",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinkSet",
                        "kind": "LinkedField",
                        "name": "linkSets",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inline",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Link",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SemanticString",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v5/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SemanticString",
                                "kind": "LinkedField",
                                "name": "meta",
                                "plural": false,
                                "selections": (v5/*: any*/),
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageUrl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "entitySlug",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SemanticString",
                                "kind": "LinkedField",
                                "name": "voyageEta",
                                "plural": false,
                                "selections": (v5/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SemanticString",
                                "kind": "LinkedField",
                                "name": "voyageEtd",
                                "plural": false,
                                "selections": (v5/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Badge",
                                "kind": "LinkedField",
                                "name": "badge",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stickyNoteContent",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ItemList_itemList_items",
            "kind": "LinkedHandle",
            "name": "items"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1183a8dcb79db3514a84aeaf94fc69b8",
    "id": null,
    "metadata": {},
    "name": "ItemListPaginationQuery",
    "operationKind": "query",
    "text": "query ItemListPaginationQuery(\n  $count: Int\n  $cursor: String\n  $dischargeDateEnd: Date\n  $dischargeDateStart: Date\n  $filters: [FilterInput!]\n  $handoverDateEnd: Date\n  $handoverDateStart: Date\n  $includeArchived: Boolean\n  $page: Int\n  $perPage: Int\n  $searchQuery: String\n  $showFilters: Boolean\n  $sortKey: String\n  $type: ListItemTypeEnum\n  $voyageEtaEnd: Date\n  $voyageEtaStart: Date\n  $voyageEtdEnd: Date\n  $voyageEtdStart: Date\n) {\n  ...ItemList_data\n}\n\nfragment Action_data on Action {\n  type\n  role\n  cta\n}\n\nfragment Badge_data on Badge {\n  type\n}\n\nfragment ContactLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  imageUrl\n}\n\nfragment ContainerLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n  badge {\n    ...Badge_data\n  }\n}\n\nfragment ItemImage_data on Image {\n  url\n  alt\n  highlight\n  shape\n  overlay\n  overlayIcon\n}\n\nfragment ItemList_data on ApplicationQuery {\n  itemList(searchQuery: $searchQuery, type: $type, filters: $filters, includeArchived: $includeArchived, sortKey: $sortKey, page: $page, perPage: $perPage, handoverDateStart: $handoverDateStart, handoverDateEnd: $handoverDateEnd, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, showFilters: $showFilters) {\n    items(first: $count, after: $cursor) {\n      edges {\n        node {\n          slug\n          ...ListPageItem_listItem\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n}\n\nfragment KeyField_data on KeyField {\n  label\n  value {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment LinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n  entitySlug\n  ...VoyageLinkCard_data\n  ...VesselLinkCard_data\n  ...ShipmentLinkCard_data\n  ...ContainerLinkCard_data\n  ...ContactLinkCard_data\n}\n\nfragment LinkSet_data on LinkSet {\n  title\n  inline\n  links {\n    key\n    type\n    ...LinkCard_data\n  }\n}\n\nfragment ListPageItem_listItem on ListItem {\n  slug\n  title\n  isArchived\n  image {\n    ...ItemImage_data\n  }\n  path\n  statuses {\n    key\n    customsAgent\n    value {\n      ...SemanticString_data\n    }\n  }\n  stages {\n    key\n    status\n    label\n    value\n  }\n  badges {\n    key\n    ...Badge_data\n  }\n  actions {\n    key\n    ...Action_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  keyFields {\n    key\n    ...KeyField_data\n  }\n  linkSets {\n    key\n    ...LinkSet_data\n  }\n  stickyNoteContent\n}\n\nfragment SemanticLine_data on SemanticLine {\n  parts {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment SemanticString_data on SemanticString {\n  text\n}\n\nfragment ShipmentLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  badge {\n    ...Badge_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n}\n\nfragment VesselLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n}\n\nfragment VoyageLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  voyageEta {\n    ...SemanticString_data\n  }\n  voyageEtd {\n    ...SemanticString_data\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b82daad2cee0c9289c2761f2fd69a93e';
export default node;
